import { h } from 'preact';

export default function ViewResetFiltersButton({
	children,
	type,
	onClickHandler
}){
	function onClick(){
		onClickHandler();
	}

	return (
		<div className={`filter-container button-filter-container button-type-${type}` }>
			<button onClick={onClick} className={type}>
				{children}
			</button>
		</div>
	);
}
